export const imgBackup = {
  BOTICARIO: '/images/mld-boticario.png',
  EUAMOMAKE: '/images/mld-euamomake.png',
  OUI: '/images/mld-oui.png',
  EUDORA: '/images/mld-eudora.png',
  MULTIMARCA: '/images/mld-multimarca.png',
};
